/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown>, count: NonNullable<unknown> }} Partner_Detail_Empty_Filter_BodyInputs */



/**
* | output |
* | --- |
* | "{month} has {count} closed periods for this partner. Widening a filter brings rows back." |
*
* @param {Partner_Detail_Empty_Filter_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_filter_body = /** @type {((inputs: Partner_Detail_Empty_Filter_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_Filter_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.month} enthält ${i?.count} abgeschlossene Zeiträume für diesen Partner. Wenn Sie einen Filter weiter fassen, erscheinen wieder Zeilen.`)
	return /** @type {LocalizedString} */ (`${i?.month} has ${i?.count} closed periods for this partner. Widening a filter brings rows back.`)
});